import React from 'react'
import { getTeamFlagUrl, isPlayoffTeam } from './worldCupTeamFlags'

export default function WorldCupTeamFlag({ name, flagCode, className = 'worldcup-match-flag' }) {
  const flagUrl = getTeamFlagUrl(name, flagCode)
  if (flagUrl) {
    return <img className={className} src={flagUrl} alt="" loading="lazy" />
  }
  if (isPlayoffTeam(name)) {
    return (
      <span className={`${className} worldcup-match-flag--playoff`} aria-hidden="true">
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill="#003087" />
          <text x="16" y="18" textAnchor="middle" fill="#fff" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">
            FIFA
          </text>
        </svg>
      </span>
    )
  }
  return <span className={`${className} worldcup-match-flag--empty`} aria-hidden="true" />
}
